module.exports = __webpack_public_path__ + "static/media/most-viewed-times-stat.b4a21e6d.svg";